module.exports = __webpack_public_path__ + "static/media/gate-icon.d1fedd16.svg";